import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-filter-pills',
  templateUrl: './filter-pills.component.html',
  styleUrls: ['./filter-pills.component.scss']
})
export class FilterPillsComponent implements OnChanges {
  @Input() genomeDisplayName: string | null = null;
  @Input() systemTagFilters: Array<{ [key: string]: string }>;

  filterPills: string[] = [];
  filterPillsTitle: string = '';

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty('systemTagFilters')) {
      this.filterPills = this.computeFilterPills();
      this.filterPillsTitle = this.filterPills.join(', ');
    }
  }

  private computeFilterPills(): string[] {
    if (!this.systemTagFilters || this.systemTagFilters.length === 0) { return []; }
    var grouped: { [key: string]: string[] } = {};
    this.systemTagFilters.forEach(function(filter) {
      Object.keys(filter).forEach(function(key) {
        if (!grouped[key]) {
          grouped[key] = [];
        }
        grouped[key].push(filter[key]);
      });
    });
    return Object.keys(grouped).map(function(key) {
      return key + ': ' + grouped[key].join('|');
    });
  }
}
